/** 1-based row result refs: "$row1.id", "$row2.workstream_id". */ const ROW_REF = /^\$row([1-9][0-9]*)\.([A-Za-z_][A-Za-z0-9_]*)$/;
export function parseDeliveryActionRowRef(value) {
    const m = ROW_REF.exec(value.trim());
    if (!m) return null;
    return {
        row: Number(m[1]),
        field: m[2]
    };
}
/** Resolve $rowN.field against prior apply results (1-based). */ export function resolveDeliveryActionParams(params, priorResults, rowIndexZeroBased, priorStatuses) {
    const out = {
        ...params ?? {}
    };
    for (const [key, raw] of Object.entries(out)){
        if (typeof raw !== 'string') continue;
        const ref = parseDeliveryActionRowRef(raw);
        if (!ref) continue;
        const priorIdx = ref.row - 1;
        if (priorIdx < 0 || priorIdx >= rowIndexZeroBased) {
            return {
                params: out,
                error: `${key}=${raw} must reference an earlier row`
            };
        }
        const prior = priorResults[priorIdx];
        if (!prior) {
            if (priorStatuses?.[priorIdx] === 'ok') {
                return {
                    params: out,
                    error: `Skipped: row ${ref.row} result unavailable after reload; ` + 're-read teams (or ask for a fresh proposal)'
                };
            }
            return {
                params: out,
                error: `Skipped: depends on row ${ref.row}, which did not apply`
            };
        }
        const resolved = prior[ref.field] ?? prior[ref.field.replace(/_([a-z])/g, (_, c)=>c.toUpperCase())] ?? prior[camelToSnake(ref.field)];
        if (!resolved) {
            return {
                params: out,
                error: `Skipped: row ${ref.row} has no result field "${ref.field}"`
            };
        }
        out[key] = resolved;
    }
    return {
        params: out
    };
}
function camelToSnake(s) {
    return s.replace(/[A-Z]/g, (ch)=>`_${ch.toLowerCase()}`);
}
